import { render, staticRenderFns } from "./AddPrescription.vue?vue&type=template&id=96341870&scoped=true"
import script from "./AddPrescription.vue?vue&type=script&lang=js"
export * from "./AddPrescription.vue?vue&type=script&lang=js"
import style0 from "./AddPrescription.vue?vue&type=style&index=0&id=96341870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96341870",
  null
  
)

export default component.exports